import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Aria from 'formvalidation/es6/plugins/Aria';
import Carousel from 'global/carousel.src';
import { inView } from 'global/inview.src';
import lottie from 'lottie-web';

/* ------------------------------------*\
    Lottie
\*------------------------------------*/
const res2dppx = window.matchMedia('(min-resolution: 2dppx)').matches;

const lotties = JSON.parse(document.querySelector('#lotties').innerHTML);

const animData = {
    'lottie-advanced_segmentation': {
        container: document.getElementById('lottie-advanced_segmentation'),
        renderer: 'svg',
        loop: lotties.advanced_segmentation.loop,
        autoplay: false,
        path: lotties.advanced_segmentation[res2dppx ? '@2x' : '@1x'],
    },
    'lottie-email_marketing': {
        container: document.getElementById('lottie-email_marketing'),
        renderer: 'svg',
        loop: lotties.email_marketing.loop,
        autoplay: false,
        path: lotties.email_marketing[res2dppx ? '@2x' : '@1x'],
    },
    'lottie-email_templates': {
        container: document.getElementById('lottie-email_templates'),
        renderer: 'svg',
        loop: lotties.email_templates.loop,
        autoplay: false,
        path: lotties.email_templates[res2dppx ? '@2x' : '@1x'],
    },
    'lottie-workflow_templates': {
        container: document.getElementById('lottie-workflow_templates'),
        renderer: 'svg',
        loop: lotties.workflow_templates.loop,
        autoplay: false,
        path: lotties.workflow_templates[res2dppx ? '@2x' : '@1x'],
    },
    'lottie-popup_templates': {
        container: document.getElementById('lottie-popup_templates'),
        renderer: 'svg',
        loop: lotties.popup_templates.loop,
        autoplay: false,
        path: lotties.popup_templates[res2dppx ? '@2x' : '@1x'],
    },
    'lottie-webpush': {
        container: document.getElementById('lottie-webpush'),
        renderer: 'svg',
        loop: lotties.webpush.loop,
        autoplay: false,
        path: lotties.webpush[res2dppx ? '@2x' : '@1x'],
    },
    'lottie-popups': {
        container: document.getElementById('lottie-popups'),
        renderer: 'svg',
        loop: lotties.popups.loop,
        autoplay: false,
        path: lotties.popups[res2dppx ? '@2x' : '@1x'],
    },
    'lottie-chats': {
        container: document.getElementById('lottie-chats'),
        renderer: 'svg',
        loop: lotties.chats.loop,
        autoplay: false,
        path: lotties.chats[res2dppx ? '@2x' : '@1x'],
    },
};

const anim = {};
anim['lottie-advanced_segmentation'] = lottie.loadAnimation(animData['lottie-advanced_segmentation']);
anim['lottie-email_marketing'] = lottie.loadAnimation(animData['lottie-email_marketing']);
anim['lottie-email_templates'] = lottie.loadAnimation(animData['lottie-email_templates']);
anim['lottie-workflow_templates'] = lottie.loadAnimation(animData['lottie-workflow_templates']);
anim['lottie-popup_templates'] = lottie.loadAnimation(animData['lottie-popup_templates']);
anim['lottie-webpush'] = lottie.loadAnimation(animData['lottie-webpush']);
anim['lottie-popups'] = lottie.loadAnimation(animData['lottie-popups']);
anim['lottie-chats'] = lottie.loadAnimation(animData['lottie-chats']);

Object.keys(anim).forEach((a) => {
    anim[a].addEventListener('loaded_images', () => {
        inView({
            elems: document.getElementById(a),
            onVisible(elem) {
                elem.classList.add('visible');
                anim[a].play();
            },
            tolerance: 0.25,
        });
    });
});

[].forEach.call(document.querySelectorAll('.carousel'), (carousel) => {
    const c = new Carousel(carousel);
});

[].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
    formValidation(form, {
        plugins: {
            aria: new Aria(),
            bootstrap3: new Bootstrap3(),
            defaultSubmit: new DefaultSubmit(),
            submitButton: new SubmitButton(),
            declarative: new Declarative({
                html5Input: true,
            }),
        },
    }).on('core.form.valid', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'GAEvent',
            eventCategory: 'Forms',
            eventAction: 'Form Submitted Success',
            eventLabel: 'prior-free-trial-form',
        });
        const submit = form.querySelector('button[type="submit"]');
        submit.disabled = true;
    });
});

[...document.querySelectorAll('.tab')].forEach((tab) => {
    tab.addEventListener('click', (e) => {
        if (!document.getElementById(tab.dataset.lottie).classList.contains('active')) {
            anim[tab.dataset.lottie].stop();
            anim[tab.dataset.lottie].play();
        }
        document.getElementById('lottie-email_templates').classList.remove('active');
        document.getElementById('lottie-workflow_templates').classList.remove('active');
        document.getElementById('lottie-popup_templates').classList.remove('active');
        document.getElementById(tab.dataset.lottie).classList.add('active');

        [...document.querySelectorAll('.tab')].forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');
    });
});
